import api, { unwrap } from './client';

/* Frais de personnel (2026-09-28) : le calcul (brut reporté, déductions, net,
   charges employeur, factures sociales) vit au SERVEUR ; les saisies passent
   par la saisie de l'exercice (`payroll_manual`) ; la source suit le pack. */
export const getPayroll = (tenantId, year) =>
  unwrap(api.get(`/financials/payroll/${tenantId}`, { params: { year } }));
